import { EffectCallback, useEffect } from "react";

export const useWindowChangeEffect = (effect: EffectCallback) => useEffect(effect, [ window.innerWidth ]);